import React, { useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  Avatar,
  Chip,
  Paper,
  useTheme,
} from "@mui/material";
import { useUpdatePhoto } from "../../../hooks/useEmployees";
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { getMediaUrl } from "../../../utils/urlHelper";

const EmpPhoto = ({ data }) => {
    const theme = useTheme();
    const [profilePic, setProfilePic] = useState(null);
    const updatePhoto = useUpdatePhoto();

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setProfilePic(URL.createObjectURL(file));
            const employee_no = data?.employee_no || "";
            updatePhoto.mutate({ employee_no, file });
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <Grid container spacing={2} justifyContent="center">
                {/* Profile Photo Section */}
                <Grid item xs={12} sm={8} md={6}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            borderRadius: '22px',
                            border: '1px solid #eef0f4',
                            textAlign: 'center',
                            background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
                            boxShadow: '0 6px 24px rgba(17,24,39,0.05)'
                        }}
                    >
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: 600,
                                mb: 3,
                                color: '#64748b',
                                textTransform: 'uppercase',
                                fontSize: '0.75rem',
                                letterSpacing: 1
                            }}
                        >
                            Profile Photo
                        </Typography>

                        <Box sx={{ position: 'relative', display: 'inline-block', mb: 3 }}>
                            <Avatar
                                src={profilePic || getMediaUrl(data?.photo)}
                                sx={{
                                    width: { xs: 150, sm: 180 },
                                    height: { xs: 150, sm: 180 },
                                    border: '6px solid white',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                                }}
                            />
                            <IconButton
                                component="label"
                                sx={{
                                    position: 'absolute',
                                    bottom: 8,
                                    right: 8,
                                    backgroundColor: '#2f6bff',
                                    color: 'white',
                                    width: 44,
                                    height: 44,
                                    boxShadow: '0 4px 12px rgba(47, 107, 255, 0.4)',
                                    '&:hover': {
                                        backgroundColor: '#2557d6',
                                        transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <PhotoCameraIcon sx={{ fontSize: 24 }} />
                                <input type="file" hidden onChange={handleImageChange} accept="image/*" />
                            </IconButton>
                        </Box>

                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5, color: '#1e293b' }}>
                            {data?.name || "Employee"}
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#64748b', mb: 3, fontWeight: 500 }}>
                            {data?.designation || "Position"}
                        </Typography>

                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5 }}>
                            <Chip
                                label={`ID: ${data?.employee_no || 'N/A'}`}
                                sx={{
                                    fontWeight: 600,
                                    bgcolor: '#f1f5f9',
                                    color: '#475569'
                                }}
                            />
                            <Chip
                                label={data?.department || 'Department'}
                                sx={{
                                    fontWeight: 600,
                                    bgcolor: `${theme.palette.primary.main}15`,
                                    color: theme.palette.primary.main
                                }}
                            />
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default EmpPhoto;
